export default __webpack_public_path__ + "static/media/placeholder.c95f9dfc.png";